import { render, staticRenderFns } from "./PrivateMessageSideBar.vue?vue&type=template&id=224cd72e&"
import script from "./PrivateMessageSideBar.vue?vue&type=script&lang=js&"
export * from "./PrivateMessageSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports